'use client'

import ApiUtils from '@/utils/ApiUtils';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { useEffect } from 'react';

export default function LogrocketPlugin(props) {
  
  useEffect(() => {
    if (props.site?.api_keys?.logrocket && props.site?.siteSettings?.monitoring?.logrocket) {
      LogRocket.init(props.site?.api_keys?.logrocket);
      setupLogRocketReact(LogRocket);
      LogRocket.identify(ApiUtils.visitorId(), {
      });
    }
  }, [])
  
  return <>
  </>
  
}